// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__UzyYc","col":"CardReaderDesc_col__vU7lK","label":"CardReaderDesc_label__1B7CW"};